'use client'

import { useState } from 'react'
import { cs } from '../../../utils'
import { ClientOnly } from '../../../utils/ClientOnly'
import { useInterval } from '../../../utils/useInterval.hook'
import styles from './Search.module.scss'

const tickerPhrases = [
  'Sage green block print flowers',
  'Black and cream ticking stripe',
  'Pink preppy palm trees',
  'Traditional dark plaid',
  'Watercolor rainbow dinosaurs',
  'Blue and Black mid-century modern geometric',
]

export function SearchTicker({ className }: { className?: string }) {
  const [tickerIndex, setTickerIndex] = useState(-1)
  const [intervalDelay, setIntervalDelay] = useState(2000)

  useInterval(() => {
    setTickerIndex((prev) => (prev === tickerPhrases.length - 1 ? 0 : prev + 1))
    if (intervalDelay !== 6000) setIntervalDelay(6000)
  }, intervalDelay)

  return (
    <div className={cs(className, styles.ticker)}>
      <ClientOnly>
        Search for...&nbsp;
        <span key={tickerPhrases[tickerIndex]}>
          {tickerPhrases[tickerIndex]}
        </span>
      </ClientOnly>
    </div>
  )
}
